import React from "react";
import { useSelector } from "react-redux";
import { AppStore } from "../../../../redux/store";
import ColorfulNameComponent from "../ColorfulName/ColorfulName";

type Props = {
  size?: number;
  className?: string;
};

const Avatar = ({ size = 28, className = "" }: Props) => {
  const user = useSelector((store: AppStore) => store.auth);

  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt=""
        style={{ width: size, height: size }}
        className={`rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div style={{ width: size, height: size }} className={`flex items-center justify-center ${className}`}>
      <ColorfulNameComponent firstName={user?.name} lastName={user?.last_name} />
    </div>
  );
};

export default Avatar;
